import styles from './textarea.module.scss';

const TextArea = (props) => {
    return (
        <div
            className={`
            ${styles.container} ${props.customClass || ''}
            ${props.error ? styles.error : ''}
            `}
            style={props.customStyle}
        >
            <p>
                {props.required ? '*' : null}
                <b>{props.label}</b>
            </p>

            <textarea value={props.value} onChange={props.onChange} disabled={props.disabled} />
        </div>
    );
};

export default TextArea;
